import React from 'react';
import styled from './index._less';
import LeftImg from '../../../image/left-img.png';



export default () => {
    return (
        <>
        <div className="left-content">
            <img src={ LeftImg } alt="" />
        </div>
        <style jsx>{ styled }</style>
      </>
    )
}
